// extracted by mini-css-extract-plugin
export default {"formField":"Oqa-z","error":"Pqa-z","disabled":"Qqa-z","fieldError":"Rqa-z","errorText":"Sqa-z","linkButton":"Tqa-z","noCode":"Uqa-z","button":"Vqa-z","acknowledgment":"Wqa-z"};